export default __webpack_public_path__ + "static/media/fa-icon-32-light.14fac8f3.svg";